export const SCROLL_TO_ID = 'container'
export const CSS_ID = 'modio-style'
